import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCopyData,
  setData,
  setErrMessage,
  setError,
} from "../../redux/dataSlice";
import { get } from "../../lib/sessionClient";

const useGetHistory = () => {
  const error = useSelector((state) => state.data.error);
  const dispatch = useDispatch();
  const [historyLoaded, setHistoryLoaded] = useState(false);
  const [isSucceed, setIsSucceed] = useState(false);
  const getHistory = async (apiEndPoint) => {
    setHistoryLoaded(true);
    setIsSucceed(false);
    try {
      const response = await get(apiEndPoint);
      dispatch(setData(response.data));
      dispatch(setCopyData(response.data));
      setIsSucceed(true);
      error && dispatch(setError("false"));
    } catch (error) {
      dispatch(setError());
      dispatch(setErrMessage(error.response?.data?.message || error.message));
    } finally {
      setHistoryLoaded(false);
    }
  };
  return { getHistory, historyLoaded, isSucceed, setIsSucceed };
};

export default useGetHistory;
